module.exports = __webpack_public_path__ + "static/media/grain-size.e63d0f82.PNG";